import { memo } from 'react';
import SearchIcon from '@mui/icons-material/Search';
export const DropsSearch = memo(({ value, onChange }) => (<div className="relative w-full sm:w-72">
		<SearchIcon sx={{ fontSize: 18 }} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground"/>
		<input type="text" placeholder="Search drops..." value={value} onChange={event => onChange(event.target.value)} className="w-full rounded-lg border border-solid border-white/[0.06] bg-white/[0.04] py-2.5 pl-10 pr-4 text-sm text-foreground placeholder:text-muted-foreground/50 focus:border-primary/40 focus:outline-none"/>
	</div>));
